/**
 *  AnimationScene
 *
 *  Created by Legman on 4/09/2015.
 *
 */

import Common       from "./Common";
import GameScene    from "./GameScene";
import EndScene     from "./EndScene";
import HelpScene    from "./HelpScene";
import IntroScene   from "./IntroScene";
import PauseScene   from "./PauseScene";
import SplashScene  from "./SplashScene";

/**
 * @class
 */
export default class Application {
    constructor() {
    }

    init() {
        this.showSplashScene();
    }

    /**
     * @param {p3.Transition} [transition]
     * @returns {p3.Scene}
     */
    showSplashScene(transition) {
        const scene = new SplashScene();
        scene.signals.next.add(function() {
            this.showIntroScene();
        }, this);

        transition = transition || new p3.FadeTransition();
        Common.scene.add(scene, transition);

        Common.audio.playMusic("music_mainmenu_screen_00");

        return scene;
    }

    /**
     * @param {p3.Transition} [transition]
     * @returns {p3.Scene}
     */
    showIntroScene(transition) {
        const scene = new IntroScene();
        scene.signals.next.add(function() {
            this.showGameScene();
        }, this);

        transition = transition || new p3.FadeTransition();
        Common.scene.add(scene, transition);

        Common.audio.playMusic("music_pause_screen_00");

        return scene;
    }

    /**
     * @param {p3.Transition} [transition]
     * @returns {p3.Scene}
     */
    showGameScene(transition) {
        Common.paused = false;

        const scene = new GameScene();
        scene.signals.next.add(function(scene, score) {
            Common.saveHighscore(score);
            this.showEndScene(score);
        }, this);
        scene.signals.pause.add(function() {
            scene.pauseGame();

            this.showPauseScene();
        }, this);

        transition = transition || new p3.FadeTransition();
        Common.scene.add(scene, transition);

        Common.audio.playMusic("music_ingame_00");

        return scene;
    }

    /**
     * @param {p3.Transition} [transition]
     * @returns {p3.Scene}
     */
    showPauseScene(transition) {
        Common.paused = true;

        const scene = new PauseScene();
        scene.signals.next.add(function() {
            Common.paused = false;

            Common.scene.remove();

            Common.audio.playMusic("music_ingame_00");
        }, this);
        scene.signals.home.add(function() {
            Common.paused = false;

            this.showSplashScene();
        }, this);

        if (!transition) {
            transition = new p3.Transition();
            transition.push = true;
            transition.replace = false;
        }
        Common.scene.add(scene, transition);

        Common.audio.playMusic("music_pause_screen_00");

        return scene;
    }

    /**
     * @param {p3.Transition} [transition]
     * @returns {p3.Scene}
     */
    showHelpScene(transition) {
        const scene = new HelpScene();
        scene.signals.next.add(function() {
            const transition = new p3.Transition();
            transition.swap = true;
            this.showPauseScene(transition);
        }, this);

        if (!transition) {
            transition = new p3.Transition();
            transition.swap = true;
        }
        Common.scene.add(scene, transition);
        return scene;
    }

    /**
     * @param {!number} [score]
     * @param {p3.Transition} [transition]
     * @returns {p3.Scene}
     */
    showEndScene(score, transition) {
        const scene = new EndScene(score);
        scene.signals.next.add(function() {
            this.showGameScene();
        }, this);
        scene.signals.home.add(function() {
            this.showSplashScene();
        }, this);

        transition = transition || new p3.FadeTransition();
        Common.scene.add(scene, transition);

        Common.audio.playMusic("music_score_screen_00");

        return scene;
    }
}
